import { CommonMessage } from '@frontend/lang';
import React from 'react';

import useTranslationContainer from './translation-container.controller';

const ID = 'stock-product-translations-container';

export interface TranslationProps {
    customClass?: string;
    ContainerTitle: React.ReactNode;
    HeaderList: React.ReactNode[];
    translations: string[];
    object: any;
}

export const TranslationContainer = (props: TranslationProps) => {
    const viewProps = useTranslationContainer(props);

    return (
        <div
            id={ID}
            className='bg-background-surface border-border-default inline-flex w-full flex-col items-start justify-start gap-6 self-stretch rounded-xl border py-4'>
            <div className='inline-flex items-center justify-start self-stretch px-4'>
                <div className='text-foreground-default justify-start text-xl font-semibold'>{props.ContainerTitle}</div>
            </div>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                {props.HeaderList.map((v, index) => {
                    const rightHeader: React.ReactNode = v;
                    const items: { [key: string]: string | null } | null = viewProps.data ? viewProps.data[index] : null;
                    return (
                        <div
                            key={index}
                            className='flex flex-col items-start justify-start self-stretch'>
                            <div className='border-border-default inline-flex items-start justify-start gap-6 self-stretch border-b px-4 py-3'>
                                <div className='text-foreground-default h-full w-64 justify-start text-base font-medium'>{CommonMessage.FORMS.LANGUAGE}</div>
                                <div className='text-foreground-default flex-1 justify-start text-base font-medium'>{rightHeader}</div>
                            </div>

                            {items &&
                                Object.entries(items).map(([key, value], i) => {
                                    const lastItem = i === Object.entries(items).length - 1;
                                    const isValue = value !== '' && value !== ' ';
                                    return (
                                        <div
                                            key={key}
                                            className={`h-fit self-stretch px-4 py-3 ${
                                                lastItem ? '' : 'border-border-default border-b'
                                            } inline-flex items-center justify-start gap-6`}>
                                            <div className='flex h-full w-64 items-start justify-start gap-2.5'>
                                                <div className='text-foreground-default justify-start text-sm font-medium'>{key}</div>
                                            </div>
                                            <div className='flex flex-1 items-start justify-start gap-2.5'>
                                                <div className='text-foreground-default justify-start text-sm font-medium'>
                                                    {value && isValue ? value : '/'}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
